<template>
  <div class="downData">
    <div class="title">
      <h3> {{$t('navbar.publicize')}}</h3>
      <div>
        <span> {{$t('publicity.tishi')}}</span>
        <button @click="addproject()"> {{$t('publicity.uploadData')}}</button>
      </div>
    </div>
    <p class="tishi">{{$t('common.sort')}}</p>
    <div class="box">
      <table>
        <thead>
          <tr>
            <th style="width: 150px; text-align:center">{{$t('common.Number')}}</th>
            <th style="width:60%">{{$t('publicity.dataName')}}</th>
            <th style="">{{$t('publicity.language')}}</th>
            <th style="width: 250px">{{$t('publicity.size')}}</th>
            <th>{{$t('common.operate')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableData" :key="index">
            <td style="text-align: center;">
              <input type="text" class="inut" v-model="item.sort" @blur="inputblur(item.id, item.sort)" />
            </td>
            <td>{{ item.informationName }}</td>
            <td>{{ item.language === 'en_US' ? '英文' : '中文' }}</td>
            <td>{{ item.size >= 1024 ? (item.size / 1024).toFixed(2) + 'Mb' : item.size + 'Kb' }}</td>
            <td>
              <div style="cursor: pointer">
                <span @click="rowEdit(item.id)"><i class="el-icon-edit-outline">{{$t('common.edit')}}</i></span>
                <span @click="del(item.id)"><i class="el-icon-delete">{{$t('common.delete')}}</i></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="item">
        <!--分页 -->
        <div class="pagination">
          <!-- <span>共{{totalNum}}条</span> -->
          <span>{{ $t('common.pagination',{ totalNum:totalNum }) }}</span>
          <el-pagination
            class="explore_right_pages"
            layout="prev, pager, next"
            :current-page="currentPage4"
            @current-change="handleCurrentChange"
            :page-size="5"
            :total="totalNum"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { travelBrochureList, delTravelBrochure, updateSort } from '../../../../api/travelBrochure.js';
export default {
  data() {
    return {
      tableData: [],
      value: '',
      currentPage4: 1,
      totalNum: 1,
      pageNum: '',
    };
  },
  created() {
    this.getLists('1');
  },
  methods: {
    addproject() {
      this.$router.push('/backIndex/uploadData');
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageNum = val
      this.getLists(this.pageNum)
    },
    async getLists(pageNum) {
      const params = {
        pageNo: pageNum,
        pageSize: 6,
      };
      try {
        const { data } = await travelBrochureList(params);
        this.tableData = data.data.list;
        this.totalNum = data.data.count
      } catch (err) {
        this.$message.error(err);
      }
    },
    rowEdit(id) {
      this.$router.push({
        name: 'uploadData',
        query: {
          id,
        },
      });
    },
    async inputblur(id, sort) {
      const params = {
        id,
        sort,
      };
      try {
        const { data } = await updateSort(params);
        if (data.code === 200) {
          this.getLists(this.pageNum);
          this.$message({
            type: 'success',
            message: this.$t('dialog.suncSort'),
          });
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    async delItem(id) {
      const params = {
        id,
      };
      try {
        const { data } = await delTravelBrochure(params);
        if (data.code === 200) {
          this.getLists(this.pageNum);
          this.$message({
            type: 'success',
            message: this.$t('dialog.deletSucce'),
          });
        }
      } catch (err) {}
    },

    del(id) {
      this.$confirm(this.$t('dialog.confirmDelete'), this.$t('dialog.attention'), {
        confirmButtonText: this.$t('dialog.sure'),
        cancelButtonText: this.$t('dialog.cancel'),
        customClass: 'myClass',
      })
        .then(() => {
          this.delItem(id);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message:  this.$t('dialog.cancelDelet'),
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.downData {
  box-sizing: border-box;
  padding: 18px 26px 0 0;
  background: white;
  height: 825px;
  .title {
    display: flex;
    justify-content: space-between;
    padding: 0px 0 18px 26px;
    border-bottom: 1px solid #e8e8e8;
    h3 {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
    button {
      width: 77px;
      height: 32px;
      background: #006fb8;
      color: white;
      border-radius: 2px;
      border: none;
      margin-left: 5px;
    }
    span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
  .tishi {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff190c;
    line-height: 18px;
    margin: 18px 0 0 26px;
  }
  .box {
    // border: 1px solid rgb(92, 0, 221);
    height: 87%;
    position: relative;
    table {
      margin: 15px 0px 0px 26px;
      border-collapse: collapse;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      border-radius: 3px 3px 0px 0px;
      overflow: hidden;
      thead {
        //width: 100%;
        background: #006fb8;
        border-radius: 4px 4px 0px 0px;
        text-align: left;
        tr {
          height: 36px;
          color: rgba(255, 255, 255, 0.85);
          width: 100%;
          th {
            box-sizing: border-box;
            height: 36px;
            width: 200px;
            color: white;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.85);
          }
        }
      }
      tbody {
        tr {
          height: 58px;
          border-bottom: 1px solid #e8e8e8;
          td {
            text-align: left;
            height: 58px;
            img {
              width: 104px;
              height: 78px;
              margin: 10px 0px;
            }
            span {
              color: #006fb8;
              margin: 0px 5px;
            }
            .inut {
              display: block;
              width: 40px;
              height: 24px;
              border: 1px solid #e0e0e0;
              line-height: 24px;
              color: #666666;
              margin-left: 25px;
              text-align: center;
            }
          }
          &:nth-child(even) {
            background-color: #f6f6f7;
          }
        }
      }

      .leaseCount {
        width: 100px;
        div {
          margin: 0 auto;
          text-align: center;
          width: 92px;
        }
      }
    }

    .item {
      // height: 40px;
      // background-color: skyblue;
      position: absolute;
      right: 0px;
      bottom: 0px;
    }
    .pagination {
      // border: 1px solid red;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 30px;
      padding-right: 0;
      span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-top: 6px;
        color: #666666;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
    margin-left: 10px;
  }
  .btn-next {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
  }
  .el-pager .number {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    margin-right: 5px;
    margin-right: 5px;
    color: #999999;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    border: none;
    cursor: pointer;
    background: #006fb8;
    color: #fff;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 28px;
    color: #999;
  }
}
</style>
<style lang="scss">
.myClass {
  border: none;
  .el-message-box__header {
    background: #006fb8;
    color: white !important;
  }
  .el-button--primary {
    background: #006fb8;
  }
}
.el-message-box__title {
  color: white !important;
}
</style>
